/* eslint-disable import/prefer-default-export */
export const fileImportQueryKeys = {
  fileImportList: (filters: any) => ["file-import", "list", filters],
  fileImportDetails: (id: string) => ["file-import", "details", id],
  fileImportActions: (id: string) => ["file-import", "actions", id],
};
